import Image from 'next/image'

interface DecorativeBackgroundProps {
  src: string
  /** Set only for the single instance that's the LCP element on its route (the `/` splash page's
   * desktop panel) — emits `fetchpriority="high"` plus an early preload, instead of being
   * discovered late like a lazy-loaded background image. */
  priority?: boolean
  sizes?: string
}

/** Full-bleed, non-interactive cover background image via `next/image` — replaces a raw CSS
 * `background-image` (which bypassed Next's automatic AVIF/WebP negotiation and fetch-priority
 * control entirely). `alt=""` since it's purely decorative, matching the prior markup's
 * `pointer-events-none` wrapper exactly. */
export function DecorativeBackground({
  src,
  priority = false,
  sizes = '100vw',
}: DecorativeBackgroundProps) {
  return (
    <div className="pointer-events-none absolute inset-0 z-0">
      <Image src={src} alt="" fill priority={priority} sizes={sizes} className="object-cover" />
    </div>
  )
}
